import { api } from 'services/api'

export const excluirCliente = async (idCliente) => {
  const url = `clientes/${idCliente}`

  const response = await api.delete(url)

  return response.data
}
